/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Cart/Cart',[
    'jquery',
    './CartManager',
    'global/all',
    'global/RocAnalytics',
    'plugins/jquery.matchHeights'
], function ($, CartManager, Roc, RocAnalytics) {
    'use strict';

    var updateTimeoutRef;
    var $processingTextbox;
    var checkoutUrl;
    var punchoutOrder;
    var cfg = window.RocConfig;

    function getItemData(element, attr) {
        return $(element).parents('.itemWrapper').attr('data-' + attr);
    }

    function updateOrderItemEvt() {
        $(document).on('change', '.itemQty .qtyTextBox', function () {
            var currentValue = parseInt($(this).val());
            var originalValue = parseInt($(this).attr('data-originalvalue'));
            var itemId = getItemData(this, 'item-id');

            if (isNaN(currentValue) || currentValue < 0) {
                Roc.UI.displayErrorPopup('There looks to be a problem with your you current quantity. Please be sure to enter the correct quantity value and try again.');
                $(this).val(originalValue);
                return;
            }

            if (currentValue !== originalValue) {
                if (updateTimeoutRef !== null) {
                    clearTimeout(updateTimeoutRef);
                    updateTimeoutRef = null;
                }
            }

            if (currentValue === 0) {
                Roc.UI.confirm('Are you sure you want to remove this item?', $.proxy(function () {
                        var itemId = getItemData(this, 'item-id');
                        CartManager.removeOrderItem(itemId);
                    }, this), 
                    $.proxy(function () { $(this).val(originalValue); return; }, this)
                );
            } else {
                updateTimeoutRef = setTimeout(doUpdateOrRemoveOrderItem, 500);
                $processingTextbox = $(this);
            }
        });
    };


    function proceedToCheckout(button, checkoutUrl) {
        Roc.Core.lockButton(button);

        if (punchoutOrder) {
            window.location.href = '/punchout/punchout-order-msg.aspx';
        } else if (cfg.google && cfg.google.isGoogleAnalyticsEcommerce && cfg.google.analyticsTrackingId) {
            var shippingList = $('#shipping-options');
            var shippingOption = shippingList.find('input[type="radio"]:checked');
            var shippingOptionName = 'Shipping Not Selected';
            var callback = function () {
                window.location.href = checkoutUrl;
            }

            if (shippingList.length > 0 && shippingOption.length > 0) {
                shippingOptionName = shippingList.find('input[type="radio"]:checked').data('rocParams').name;
            }

            RocAnalytics.recordCheckoutOption(1, shippingOption, callback);
        } else {
            window.location.href = checkoutUrl;
        }
    };

    // Self Initializes on dom ready
    $(document).ready(function () {
        updateOrderItemEvt();

        $(document).on('click', '[data-roc-action="proceedToCheckout"]', function () {
            proceedToCheckout('[data-roc-action="proceedToCheckout"]', checkoutUrl)
        });
    });

    // resets sliding cart size/positioning
    function sizeReset() {
        $('.slideCartRail').each(function () {
            var cartSummary = $('.slideCart');

            $('.slideCartCompanion, .slideCartRail').css('min-height', '0').matchHeights({
                minHeight: cartSummary.outerHeight(true)
            });
        });

    };

    // removal of associated item promo notification within cart
    function removeItemNotification(e, currentItem) {
        var notification = currentItem.next('.itemNotofication');

        if (notification.length) {
            notification.fadeOut('400');

            setTimeout(function () {
                // remove notification from the DOM
                notification.remove();
            }, 400);
        }
    };

    // Check if cart group is empty, and remove group if it is
    function isCartEmpty(currentCart) {
        setTimeout(function () {
            if (!currentCart.find('.productListInner .itemWrapper').length) {
                // remove current cart group from the DOM
                currentCart.remove();
            }
        }, 500);

        setTimeout(function () {
            sizeReset();
        }, 600);
    };

    function doUpdateOrRemoveOrderItem() {
        $('.qtyTextBox').attr('disabled', true);
        var requestData = {
            'OrderItemId': getItemData($processingTextbox, 'item-id'),
            'Quantity': $processingTextbox.val(),
            'OrderId': '{orderId}'
        };

        $processingTextbox = null;
        updateTimeoutRef = null;
        CartManager.updateCartItem(requestData);
    };

    function init(options){
        checkoutUrl = options.checkoutUrl;
        punchoutOrder = options.punchoutOrder;
    }

    var Cart = {
        init: init,
        sizeReset: sizeReset,
        removeItemNotification: removeItemNotification,
        isCartEmpty: isCartEmpty,
        doUpdateOrRemoveOrderItem: doUpdateOrRemoveOrderItem,
        proceedToCheckout: proceedToCheckout
    };

    return Cart;
});
